'use strict';

var _ = require('lodash');
var RecommendationFilterService = function RecommendationFilterService(faresOptimizerConstants) {
  var FILTER_MODES = {
    INCLUSIVE: 'INCLUSIVE',
    EXCLUSIVE: 'EXCLUSIVE'
  };
  function buildFilter(mode, filterArgs) {
    return {
      mode: mode,
      filterArgs: filterArgs
    };
  }
  function optimizeFilters(filters) {
    var ignoreExlucsiveFiltering = [faresOptimizerConstants.AUTO_APPROVAL_STOPPED_KEY];
    return _.chain(filters).reduce(function (result, item, key) {
      if (!item.selected) {
        result[key] = buildFilter(FILTER_MODES.INCLUSIVE, []);
      } else if (item.selected.length !== item.available.length) {
        if (item.selected.length > item.available.length / 2 && ignoreExlucsiveFiltering.indexOf(key) === -1) {
          result[key] = buildFilter(FILTER_MODES.EXCLUSIVE, _.difference(item.available, item.selected));
        } else {
          result[key] = buildFilter(FILTER_MODES.INCLUSIVE, _.clone(item.selected));
        }
      }
      return result;
    }, {}).value();
  }
  function filterByProperty(item, filter, property) {
    if (filter) {
      var value = item[property];
      var itemFound = _.isArray(value) ? _.isEmpty(_.intersection(filter.filterArgs, value)) : filter.filterArgs.indexOf(value) === -1;
      return filter.mode === FILTER_MODES.EXCLUSIVE ? itemFound : !itemFound;
    }
    return true;
  }
  function filterRawData(rawData, filters, category) {
    var optimizedFilters = optimizeFilters(filters);
    function filterOut(item) {
      var result = true;
      _.forEach(optimizedFilters, function (filter, property) {
        result = result && filterByProperty(item, filter, property);
      });
      return result;
    }
    if (category === 'detailsPanel') {
      return _.chain(rawData).filter(filterOut).value();
    } else {
      return _.chain(rawData).filter({
        category: category
      }).filter(filterOut).value();
    }
  }
  return {
    filterRawData: filterRawData
  };
};
RecommendationFilterService.$inject = ['FaresOptimizerConstants'];
module.exports = RecommendationFilterService;